var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-build',{attrs:{"form-name":"editForm","form-data":_vm.data,"form-rules":_vm.editFormRules,"form-columns-group":_vm.editFormColumnsGroup,"form-buttons":_vm.editFormButtons},on:{"update:formData":function($event){_vm.data=$event},"update:form-data":function($event){_vm.data=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a35b729c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/CompanyEditComponent.vue
// module id = null
// module chunks = 